import { render } from "./TabletOnBoarding.vue?vue&type=template&id=7c895b06"
import script from "./TabletOnBoarding.vue?vue&type=script&lang=js"
export * from "./TabletOnBoarding.vue?vue&type=script&lang=js"

import "./TabletOnBoarding.vue?vue&type=style&index=0&id=7c895b06&lang=css"

import exportComponent from "/home/api.muzea.ro/wp-content/themes/szmm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__